import { createGlobalStyle } from 'styled-components';
import { loginTheme } from '../theme/loginTheme';

// Login UI is intentionally pinned to loginTheme (dark), not the active app theme.
const CssLogin = createGlobalStyle`
  /* Keep page chrome dark while the authenticator is visible (e.g. light mode saved). */
  body:has([data-amplify-authenticator]) {
    background: ${loginTheme.colors.background_dashboard};
    color: ${loginTheme.colors.text};
  }

  [data-amplify-authenticator] {
    display: grid;
    justify-content: flex-start;
    height: 100vh;
    background-image: url("login-slider.jpg");
    background-size: calc(1920px - 546px);
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: right;
  }

  [data-amplify-authenticator] [data-amplify-container]{
    width: 546px;
    height: inherit;
    padding: 32px;
    background: ${loginTheme.colors.black};;
  }
  
  [data-amplify-authenticator] [data-amplify-router] {
    margin-top: 170px;
    background: inherit;
    border: none;
  }

  @media (max-height: 800px) {
    [data-amplify-authenticator] [data-amplify-router] {
      margin-top: 80px;
    }
  }

  [data-amplify-authenticator] [data-amplify-form] {
    padding: 24px 0 0 0;

    .amplify-heading {
      color: ${loginTheme.colors.text};
    }

    .amplify-field {
      height: 74px;
      position: relative;

      .amplify-text {
        color: ${loginTheme.colors.text};
      }

      .amplify-label {
        position: absolute;
        top: 16px;
        left: 16px;
        color: ${loginTheme.colors.text};
        font-family: ManropeLight, sans-serif;
        font-size: 13px;
      }
      
      .amplify-field-group {
        height: 100%;
        background-color: ${loginTheme.colors.widget_background};
        border-radius: 12px;
        border: 1px solid ${loginTheme.colors.outline};
        transition: all .2s ease-in;

        &:has(input:focus) {
          border: 1px solid ${loginTheme.colors.main_cta};
          border-radius: 12px;
        }
        
        .amplify-field-group__field-wrapper {
          height: 100%;
          
          .amplify-input {
            height: 100%;
            border: none;
            border-radius: 12px;
            padding-top: 30px;
            color: ${loginTheme.colors.white};
            caret-color: ${loginTheme.colors.main_cta};

            ::placeholder {
              position: absolute;
              top: 38px;
              color: ${loginTheme.colors.inactive};
              font-size: 13px;
            }

            ::-webkit-inner-spin-button {
              -webkit-appearance: none;
            }
            
            &:focus {
              border: none;
              box-shadow: none;
            }
          }
        }
        
        .amplify-field-group__outer-end {
          button {
            border: none;
            color: ${loginTheme.colors.main_cta};

            &:hover, &:focus, &:active {
              border-radius: 12px;
              box-shadow: none;
              background-color: ${loginTheme.colors.widget_background};
            }
          }
        }
      }
    }
  }

  [data-amplify-authenticator] input:-webkit-autofill,
  [data-amplify-authenticator] input:-webkit-autofill:hover,
  [data-amplify-authenticator] input:-webkit-autofill:focus,
  [data-amplify-authenticator] input:-webkit-autofill:active {
    -webkit-text-fill-color: ${loginTheme.colors.white};
    background-color: ${loginTheme.colors.widget_hover_background} !important;
    -webkit-box-shadow: 0 0 0 1000px ${loginTheme.colors.widget_hover_background} inset !important;
    border: 1px solid ${loginTheme.colors.widget_hover_background};
  }

  .amplify-button[data-variation='primary'] {
    width: 150px;
    height: 34px;
    border-radius: 6px;
    background-color: ${loginTheme.colors.main_cta};
    color: ${loginTheme.colors.black};
    text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
    box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
    font-family: ManropeBold, sans-serif;
    font-size: 13px;
    transition: all .2s ease-in;
  }

  .amplify-button[data-variation='primary']:hover {
    background-color: ${loginTheme.colors.white};
  }

  .amplify-button[data-variation='link'] {
    position: absolute;
    left: 408px;
    width: 119px;
    height: 34px;
    color: ${loginTheme.colors.main_cta};
    font-family: ManropeLight, sans-serif;
    font-size: 13px;
    transition: all .2s ease-in;
  }

  .amplify-button[data-variation='link']:hover {
    background-color: inherit;
    color: ${loginTheme.colors.text};
  }

  form[data-amplify-authenticator-resetpassword] .amplify-button[data-variation='link'] {
    display: none;
  }

  .amplify-alert__body {
    padding-right: 25px;
  }

  .amplify-button.amplify-alert__dismiss {
    left: 473px;
    width: 20px;
    color: var(--amplify-components-alert-error-color);
    background-color: unset;
  }
  
  .amplify-text--error {
    color: ${loginTheme.colors.red};
  }
`;

export default CssLogin;
